import React from 'react';
import { Button, Icon, Box } from '@chakra-ui/react';
import { ArrowsUpDownIcon } from '@heroicons/react/24/outline';
import {
  MenuContent,
  MenuRadioItemGroup,
  MenuRoot,
  MenuRadioItem,
  MenuTrigger,
} from '@/components/ui/menu';

interface Props {
  sortKey: string;
  onSortChange: (value: string) => void;
}

const SortItems = [
  { value: 'recent', label: 'Recent' },
  { value: 'titleAsc', label: 'Title A-Z' },
  { value: 'titleDesc', label: 'Title Z-A' },
];

const Sort: React.FC<Props> = ({ sortKey, onSortChange }) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <Button colorPalette='brand' variant='ghost' size='sm'>
          <Icon as={ArrowsUpDownIcon} w={4} h={4} />
          <Box display={{ base: 'none', md: 'block' }}>
            Sort by {SortItems.find((item) => item.value === sortKey)?.label}
          </Box>
          <Box display={{ base: 'block', md: 'none' }}>
            {SortItems.find((item) => item.value === sortKey)?.label}
          </Box>
        </Button>
      </MenuTrigger>
      <MenuContent minW='10rem'>
        <MenuRadioItemGroup value={sortKey} onValueChange={(e) => onSortChange(e.value)}>
          {SortItems.map((item) => (
            <MenuRadioItem key={item.value} value={item.value}>
              {item.label}
            </MenuRadioItem>
          ))}
        </MenuRadioItemGroup>
      </MenuContent>
    </MenuRoot>
  );
};

export default Sort;
